export { default as ModalFeedback } from './ModalFeedback'
export { default as FeedbackReducer } from './model/slice'
